import { BillingType, EntryType } from '../../generated'

export const getBillableStatus = (param: {
  billingType?: BillingType
  entryType?: EntryType
  isFlatFeeHoursExhausted?: boolean | null
}): boolean => {
  const { billingType, isFlatFeeHoursExhausted, entryType } = param
  if (!billingType) return true

  const isLegalFee = entryType === EntryType.Legal
  const isExpenseEntry = entryType === EntryType.Expense
  const isCostEntry = entryType === EntryType.Cost
  const isTimeEntry = entryType === EntryType.Time

  switch (billingType) {
    case BillingType.Hourly:
      return true
    case BillingType.FlatFee:
      return !!(isLegalFee || isExpenseEntry || isCostEntry)
    case BillingType.Hybrid:
      if (isTimeEntry || isCostEntry) return !!isFlatFeeHoursExhausted
      return !!(isLegalFee || isExpenseEntry)
    case BillingType.Contingency:
    case BillingType.ContingencyHybrid:
      return !!(isExpenseEntry || isCostEntry)
    case BillingType.ProBono:
      return !!isCostEntry
    default:
      return false
  }
}
